import { Box } from "@mui/material";

/**
 * Terminal landing for a user who can't view any page (e.g. no memberships yet, so empty
 * caps). Renders a message instead of redirecting — this is what breaks the guard cycle
 * (/ → /collections → /dashboard → /) that otherwise loops for a capless user.
 */
export default function NoAccess() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        minHeight: "60vh",
        textAlign: "center",
        px: 3,
      }}
    >
      <Box
        sx={{ fontFamily: "var(--font-crimson)", fontSize: 24, color: "var(--color-rodeo-black)" }}
      >
        No access yet
      </Box>
      <Box sx={{ fontSize: 15, color: "var(--color-graphite)", maxWidth: 420 }}>
        Your account doesn't have access to any pages. If this is unexpected, ask your administrator
        to assign you a role.
      </Box>
    </Box>
  );
}
